import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SelectInput from '../../Global/Inputs/OutlinedSelect';
import DateFieldInput from '../../Global/Inputs/DateField';
import TextFieldInput from '../../Global/Inputs/TextField';
import { withNamespaces } from 'react-i18next';
import { Field, FastField } from 'formik';
import combineStyles from '../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';
import GridItem from '../../Global/GridItem';
import Autocomplete from '../../Global/Inputs/Autocomplete';
import FormItemContainer from './../../Global/Containers/FormItemContainer';
import { AppContext } from '../../../AppProvider';
import { SHIPMENT_STATUS, DATATYPES } from '../../../constants/constants';

const styles = theme => ({
  basicInfoGridContainer: {
    marginTop: theme.spacing.unit * 1.5
  }
});

export class BasicInfo extends Component {
  static propTypes = {
    shipmentModeId: PropTypes.string,
    plannedToTimeLocal: PropTypes.string,
    shipmentDirectionId: PropTypes.string,
    totalLinearFeet: PropTypes.oneOfType([PropTypes.number]),
    glCodeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleChange: PropTypes.func.isRequired,
    handleValidateField: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    glCodes: PropTypes.array.isRequired,
    bolNumber: PropTypes.string,
    proNumber: PropTypes.string,
    carrierPickupNumber: PropTypes.string,
    shipmentStatusId: PropTypes.string.isRequired
  };
  state = { glCode: this._getInitialglCode() };

  _getInitialglCode() {
    const { glCodeId, glCodes } = this.props;
    if (glCodeId) {
      const selectectedGlCode = glCodes.find(
        code => glCodeId === Number(code.id)
      );
      return _get(selectectedGlCode, 'name', `GL CODE ID - ${glCodeId}`);
    }
    return '';
  }
  _getSuggestions = async value => {
    const { glCodes } = this.props;
    const valueToLower = value.toLowerCase();

    const suggestionResults = glCodes.filter(
      code =>
        code.name.toLowerCase().includes(valueToLower) ||
        code.externalId.toLowerCase().includes(valueToLower)
    );
    const suggestions = suggestionResults.map(result => {
      return {
        label: `${result.externalId} - ${result.name}`,
        ...result
      };
    });

    return Promise.resolve(suggestions);
  };
  _getGLCodeValue = selectedGLCode => {
    return selectedGLCode.label;
  };
  _onGLCodeSelected = selectedCode => {
    const { setFieldValue } = this.props;
    setFieldValue('glCodeId', Number(selectedCode.id));
  };
  _onGLCodeChanged = change => {
    this.setState({ glCode: change });
  };

  render() {
    const {
      classes,
      handleChange,
      t,
      shipmentModeId,
      plannedToTimeLocal,
      totalLinearFeet,
      bolNumber,
      proNumber,
      carrierPickupNumber,
      shipmentDirectionId,
      shipmentStatusId,
      handleValidateField
    } = this.props;
    const {
      shipmentModes,
      shipmentDirections
    } = this.context.globalProps.referenceData;
    const { glCode } = this.state;
    const hideNumberFields = ['', SHIPMENT_STATUS.SAVED].includes(
      shipmentStatusId
    );
    return (
      <FormItemContainer title={t('Basic Information')}>
        <Grid
          container
          spacing={16}
          classes={{ container: classes.basicInfoGridContainer }}
        >
          <GridItem lg={3}>
            <FastField
              name="shipmentModeId"
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <SelectInput
                    value={shipmentModeId}
                    field={field}
                    form={form}
                    classes={{ root: classes.noMarginBottom }}
                    label={t('Shipment Type')}
                    options={shipmentModes}
                    validateField={handleValidateField}
                    multiple={false}
                    withError={true}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem item lg={3}>
            <FastField
              name="shipmentDirectionId"
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <SelectInput
                    value={shipmentDirectionId}
                    field={field}
                    form={form}
                    label={t('Shipment Direction')}
                    options={shipmentDirections}
                    validateField={handleValidateField}
                    multiple={false}
                    withError={true}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              name={'pickup.plannedToTimeLocal'}
              onChange={handleChange}
              render={({ field, form }) => (
                <DateFieldInput
                  value={plannedToTimeLocal}
                  field={field}
                  form={form}
                  validateField={handleValidateField}
                  label={t('Planned Pickup Date')}
                  format={'MMM DD, YYYY'}
                />
              )}
            />
          </GridItem>
          <GridItem lg={3}>
          <FastField
              name={`totalLinearFeet`}
              
              onChange={handleChange}
              validateField={handleValidateField}
              render={({ field, form }) => {
                return (
                 <TextFieldInput 
                  value={totalLinearFeet}
                  form={form}
                  field={field}
                  label={t('Linear Feet')}
                  type="number"
                  endAdornment={'ft'}
                  datatype={DATATYPES.NUMBER}
                 />
                );
              }}
            />           
          </GridItem>
          <GridItem lg={3}>
            <Field
              name={`glCodeId`}
              render={({ field, form }) => {
                return (
                  <Autocomplete
                    value={glCode || ''}
                    getSuggestions={this._getSuggestions}
                    getSuggestionValue={this._getGLCodeValue}
                    onSuggestionSelected={this._onGLCodeSelected}
                    label={t('GL Code')}
                    onChange={this._onGLCodeChanged}
                    validateField={handleValidateField}
                    field={field}
                    form={form}
                  />
                );
              }}
            />
          </GridItem>
          {!hideNumberFields && (
            <GridItem lg={3}>
              <Field
                label={t('Pro Number')}
                value={proNumber}
                name={'proNumber'}
                onChange={handleChange}
                component={TextFieldInput}
                validateField={handleValidateField}
              />
            </GridItem>
          )}
          {!hideNumberFields && (
            <GridItem lg={3}>
              <Field
                label={t('BOL Number')}
                value={bolNumber}
                name={'bolNumber'}
                onChange={handleChange}
                component={TextFieldInput}
              />
            </GridItem>
          )}
          {!hideNumberFields && (
            <GridItem lg={3}>
              <Field
                label={t('Carrier Pickup ID')}
                value={carrierPickupNumber}
                name={'carrierPickupNumber'}
                onChange={handleChange}
                component={TextFieldInput}
              />
            </GridItem>
          )}
        </Grid>
      </FormItemContainer>
    );
  }
}

BasicInfo.contextType = AppContext;
const BasicInfoTranslated = withNamespaces()(BasicInfo);
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, SpacingStyles, styles)
)(BasicInfoTranslated);
